/* Pont Shopify : retrouve la variante réelle (taille+coloris) injectée par Liquid. */
window.CG_FIND_VARIANT = function (sizeId, colorId) {
  var p = window.CG_PRODUCT;
  if (!p || !p.variants) return null;
  var colorWord = (colorId === 'rose') ? 'rose' : 'bleu';
  var su = String(sizeId || '').toUpperCase();
  for (var i = 0; i < p.variants.length; i++) {
    var v = p.variants[i];
    var o1 = String(v.o1 || '').toLowerCase();
    var o2 = String(v.o2 || '').toUpperCase();
    if (o2.indexOf(su) === 0 && o1.indexOf(colorWord) >= 0) return v;
  }
  return null;
};
window.CG_ADD_TO_CART = function (items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items }),
  }).then(function (r) { if (!r.ok) throw new Error('cart add failed'); return r.json(); });
};
